/**
 * Conta notificações não lidas.
 * Critério: sem `readAt` e `status !== "read"`.
 *
 * @param {Array<{ readAt?: string|null, status?: string }>} [notifications]
 * @returns {number}
 */
export function countUnreadNotifications(notifications) {
  if (!Array.isArray(notifications)) return 0;

  return notifications.filter((item) => {
    if (!item) return false;
    if (item.status === "read") return false;
    if (typeof item.readAt === "string" && item.readAt.trim()) return false;
    return true;
  }).length;
}
